import { render, staticRenderFns } from "./OrderCustomerCard.vue?vue&type=template&id=4560dc5a&"
import script from "./OrderCustomerCard.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderCustomerCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports